export default "__VITE_ASSET__JtbeY8MN__"